import {
  Avatar,
  FlexRow,
  FlexCell,
  Panel,
  Text,
  IconContainer,
  Tooltip,
} from '@epam/loveship'
import { ReactComponent as Calendar } from '@epam/assets/icons/common/action-calendar-12.svg'
import { ReactComponent as Location } from '@epam/assets/icons/common/action-map_pin-12.svg'
import { ReactComponent as Mic } from '@epam/assets/icons/common/action-mic-24.svg'
import Moment from 'react-moment'
import { ExtendedEvent } from '../../../../../../constants/types'
import { useSideBarControlls } from '../../../../../../hooks/useSideBarControlls'
import { MAX_CHAR_LIMIT } from '../../../../../../constants/values'
import { useEffect, useRef, useState } from 'react'
import css from './EventCard.module.scss'

interface EventCardProps {
  extendedEvent: ExtendedEvent
}

export const EventCard: React.FC<EventCardProps> = ({ extendedEvent }) => {
  const {
    id,
    name,
    time,
    organizers,
    categoryName = '',
    language,
    location,
  } = extendedEvent

  const categoryClassNames: Record<string, string> = {
    Other: 'categoryOther',
    Entertainment: 'categoryEntertainment',
    Education: 'categoryEducation',
    Sport: 'categorySport',
    Relaxation: 'categoryRelax',
    'Culture and arts': 'categoryCulture',
  }

  const currentCategoryClassName = categoryClassNames[categoryName]

  const categoryClassName = css.eventCategoryText
  const additionalClassName = css[currentCategoryClassName]
  const combinedClassName = [categoryClassName, additionalClassName].join(' ')

  const { showEventInfo } = useSideBarControlls()
  const nameHiddenRef = useRef<HTMLDivElement>(null)
  const [tooltipContent, setTooltipContent] = useState('')

  useEffect(() => {
    const nameHiddenWidth = nameHiddenRef?.current?.offsetWidth ?? 0
    if (nameHiddenWidth > MAX_CHAR_LIMIT.FIELD_LENGTH_TOOLTIP_NAME) {
      setTooltipContent(name)
    }
  }, [name])

  return (
    <div className={css.eventsCardContainer}>
      <FlexRow
        vPadding="12"
        spacing="12"
        padding="24"
        onClick={() => showEventInfo(extendedEvent)}
      >
        <Panel style={{ width: '100%' }} background="white" shadow>
          <FlexRow padding="12">
            <IconContainer cx={css.micCalendar} icon={Calendar} />
            <Text cx={css.dateText} font="sans">
              <Moment format="DD MMM YYYY ">{time}</Moment>
            </Text>
            <IconContainer cx={css.micLocation} icon={Location} />
            <Text cx={css.dateText} font="sans" rawProps={{ title: location }}>
              {location}
            </Text>
            <IconContainer cx={css.micIcon} icon={Mic} />
            <Text cx={css.dateTextLanguage} font="sans">
              {language}
            </Text>
          </FlexRow>

          <FlexRow cx={css.eventCategory} padding="12" vPadding="12">
            <FlexCell width="100%">
              <Text cx={combinedClassName} font="sans">
                {categoryName}
              </Text>
            </FlexCell>
          </FlexRow>

          <FlexRow padding="12">
            <Tooltip
              content={tooltipContent}
              placement="left-start"
              color="white"
            >
              <Text
                cx={css.evenInfoText}
                lineHeight="24"
                fontSize="18"
                font="sans-semibold"
              >
                {name}
              </Text>
            </Tooltip>
          </FlexRow>

          <FlexRow cx={css.hiddenText} padding="12">
            <Text
              ref={nameHiddenRef}
              lineHeight="24"
              fontSize="18"
              font="sans-semibold"
            >
              {name}
            </Text>
          </FlexRow>

          {organizers &&
            organizers.map((organizer: any) => {
              return (
                <FlexRow key={id} padding="12">
                  <Text cx={css.organizerText} font="sans">
                    Organizer:
                  </Text>
                  <Avatar
                    alt={organizer?.name}
                    img={organizer?.picture}
                    size="24"
                  />
                  <Text cx={css.organizerNameText} font="sans">
                    {organizer?.name}
                  </Text>
                </FlexRow>
              )
            })}
        </Panel>
      </FlexRow>
    </div>
  )
}
